var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-track-wrap" }, [
    _c("div", { staticClass: "numList flex-row-start-center" }, [
      _c("div", { staticStyle: { width: "60px" } }, [_vm._v("包裹号：")]),
      _vm._v(" "),
      _vm.numberList.length
        ? _c(
            "div",
            {},
            _vm._l(_vm.numberList, function(item) {
              return _c(
                "span",
                {
                  key: item.box_code,
                  staticClass: "no_item",
                  class: _vm.currentNo == item.box_code ? "active" : "",
                  on: {
                    click: function($event) {
                      return _vm.getDetail(item.box_code)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item.box_code) + "\n      ")]
              )
            }),
            0
          )
        : _c("div", [_vm._v("暂无包裹")])
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "order-track-title" }, [_vm._v("物流轨迹：")]),
    _vm._v(" "),
    _vm.list.length
      ? _c(
          "div",
          { directives: [{ name: "loading", rawName: "v-loading" }] },
          _vm._l(_vm.list, function(actionItem, index) {
            return _c(
              "div",
              { staticClass: "line-item flex-row-start-start" },
              [
                _c("div", { staticClass: "line-status" }, [
                  _vm._v(_vm._s(actionItem.actionTagName))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "line-info" }, [
                  _c("div", {
                    staticClass: "line-item-tail",
                    class: index == _vm.list.length - 1 ? "last" : ""
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "line-item-point",
                      class:
                        _vm.list.length > 1
                          ? index == _vm.list.length - 1
                            ? "last"
                            : index == 0
                            ? "first"
                            : ""
                          : "last only_one"
                    },
                    [
                      index == _vm.list.length - 1
                        ? _c("span", [_vm._v("发")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list.length > 1 && index == 0
                        ? _c("i", {
                            staticClass: "el-icon-document",
                            staticStyle: { color: "white" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "line-content" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(actionItem.actionDate) +
                        "   " +
                        _vm._s(actionItem.message) +
                        "\n        "
                    )
                  ])
                ])
              ]
            )
          }),
          0
        )
      : _c("div", { staticClass: "order-track-title" }, [_vm._v("暂无数据")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-086b1b6b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-086b1b6b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-track.vue
// module id = null
// module chunks = 